/**
 * "Oct 31 – Nov 3" from the store's own delivery days (per-city when the
 * store set one for the customer's city). Returns null when the store
 * hasn't stated delivery times -- the page then shows nothing.
 */
export function deliveryRange(policies, { city = null, now = new Date(), locale } = {}) {
  if (!policies) return null;
  let lo = policies.delivery_days_min;
  let hi = policies.delivery_days_max;
  const perCity = city && policies.delivery_city_days?.[String(city).trim().toLowerCase()];
  if (Array.isArray(perCity)) [lo, hi] = perCity;
  if (lo == null && hi == null) return null;
  lo = lo ?? hi;
  hi = hi ?? lo;
  const start = new Date(now);
  const end = new Date(now);
  start.setDate(start.getDate() + Number(lo));
  end.setDate(end.getDate() + Number(hi));
  const fmt = (d) => d.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
  return lo === hi ? fmt(start) : `${fmt(start)} – ${fmt(end)}`;
}
